import { Heading } from '@ankor-io/ui-components/src/Heading'
import { Loading } from '@ankor-io/ui-components/src/Loading'

import { useMinimumDisplayTime } from '@/hooks/useMinimumDisplayTime'
import { useConnectedAccount } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'
import ConnectedAccountDetail from '@/views/apa/Dashboard/ConnectedAccountDetail'
import Welcome from '@/views/apa/Dashboard/Welcome'

const DashboardPage: React.FC = () => {
  const { isLoading } = useConnectedAccount()
  const showLoader = useMinimumDisplayTime(isLoading, 1000)

  const { activeConnectedAccountId } = useUserContext()
  if (showLoader) {
    return <Loading />
  }

  if (activeConnectedAccountId) {
    return (
      <>
        <Heading
          level={3}
          className="mb-6"
        >
          APA - Dashboard
        </Heading>
        <ConnectedAccountDetail />
      </>
    )
  }

  return (
    <>
      <Heading
        level={3}
        className="mb-6"
      >
        APA - Dashboard
      </Heading>
      <Welcome />
    </>
  )
}

export default DashboardPage
